export default __webpack_public_path__ + "static/media/shoes2.8feb1998.jpeg";